import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants";
import { CreateFeedInsertRequestBody } from "./createFeedInsert.types";

export const requestCreateFeedInsert = async (
  body: CreateFeedInsertRequestBody
): Promise<void> => {
  return await instance.post(ApiRoutesContent.FeedInserts, body);
};
